import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useResource, useStore, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SF_REGN_CD_SRCH,
    SG_REGN_CD_LIST,
} from "@/tra/tancis/ptli/comnmdle/curr/service/PtliCurrCdService";

/*
 * Currency Code Management List
 * !== 통화 코드 관리 목록 ==!
 */
export const PTLI0416001Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "COM0033" }],
    });

    const pgeUid = "UI-PTLI-0415-001Q";
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();

    const form = {
        regnCdSrch: useForm({
            defaultSchema: SF_REGN_CD_SRCH,
            defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        currCdList: useGrid({
            defaultSchema: SG_REGN_CD_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Retrieve a list of Currency codes. !== 통화코드 목록을 조회한다.==!
        getCurrCdList: useFetch({
            api: (page = grid.currCdList.page) =>
                APIS.getRegnCdList(form.regnCdSrch.getValues(), page, grid.currCdList.size),
            enabled: comnUtils.isEmpty(form.regnCdSrch.errors),
            key: [grid.currCdList.page, grid.currCdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.regnCdSrch.getValues(),
                    page: grid.currCdList.page,
                    size: grid.currCdList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            regnCd: (props: any) => {
                const { rowValues, value } = props;
                return (
                    <Link to={`${URLS.ptli0415003s}/${rowValues.regnCd}-${rowValues.cntyCd}-${rowValues.regnTpCd}`}>
                        {value}
                    </Link>
                );
            },
        },
    };

    const handler = {
        getCurrCdList: () => {
            grid.currCdList.setPage(0);
            fetch.getCurrCdList.fetch(0);
        },
    };

    useEffect(() => {
        handler.getCurrCdList();
    }, []);

    return (
        <Page
            id={pgeUid}
            title={t("T_REGN_CD_MGMT")}
            navigation={{
                base: comnEnvs.base,
                nodes: [...BASE.nodes, { path: URLS.ptli0415001q, label: "T_REGN_CD_MGMT"}],
            }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.regnCdSrch.schema.cntyCd} />
                            <Group.Control {...form.regnCdSrch.schema.regnTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdSrch.schema.regnCd} />
                            <Group.Control {...form.regnCdSrch.schema.regnNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.regnCdSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getCurrCdList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.currCdList.grid} data={fetch.getCurrCdList.data?.currCdList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role={"new"}
                    onClick={() => {
                        navigate(URLS.ptli0415002s);
                    }}
                />
            </Layout.Left>
        </Page>
    );
};
